import React from 'react';

const Logo = () => {
    return ( 
        <div className='logocont'>
        <div className='logo'></div>
        <h5 className='name'>TravelExpo</h5>
        </div>
     );
}

export default Logo;